import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { es_ES,NzI18nService } from 'ng-zorro-antd/i18n';
import { AuthenticationService } from './shared/services/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {


    constructor(
        private i18n: NzI18nService,
        private authenticationService: AuthenticationService,
        private router: Router
    ){
        this.i18n.setLocale(es_ES);

    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }

}
